/* eslint-disable no-underscore-dangle */
// This class manages visibility of primary page components for the Lightspeed Retail UI.
// Components should be managed via this class only to make sure all pieces are collected properly

/**
 * Generate a jQuery selector from the supplied list
 * @param {Array} list - list of components
 * @returns {String} jQuery selector
 * @private
 */
const componentsAsSelectors = (list: TSFixMe) => {
  return _.map(list, component => `#${component}`).join(',');
};

class Page implements MerchantosPage {
  components: string[];

  constructor() {
    // List of allowed components
    this.components = ['section', 'listing', 'view', 'register'];
  }

  /**
   * Display a component
   * @param {String} component - A component to show
   * @param {Object} [options] - Optional response object
   */
  show = (component: string, options: TSFixMe) => {
    if (!this.components.includes(component)) return;

    this.hide(_.difference(this.components, [component]));

    const workingComponent = $(`#${component}`);

    if (options && options.html) {
      if (workingComponent.length > 1) {
        // TODO: Where is this coming from???
        // @ts-expect-error ts-migrate(2304) FIXME: Cannot find name 'RenderException'.
        throw new RenderException(
          "Rendering content to multiple DOM locations. This shouldn't happen."
        );
      }

      // If a container class is specified use an existing object with that class or create it
      if (options.container_class) {
        let insertionPoint = workingComponent.find(`.${options.container_class}`);
        // If there are no matches then create the insertion point
        if (insertionPoint.length === 0) {
          insertionPoint = $('<div>').addClass(options.container_class);
          workingComponent.append(insertionPoint);
        }
        insertionPoint.htmlReplace(options.html);
      } else {
        workingComponent.htmlReplace(options.html);
      }
    }

    window.merchantos.print.showPrintLabelButtonsOnStencil();

    workingComponent.fadeIn('fast');
  };

  /**
   * Hide one or more components
   * @param {String|Array} component - list of components
   */
  hide = (component: TSFixMe) => {
    let componentsToHide = component || this.components;
    if (!Array.isArray(componentsToHide)) {
      componentsToHide = [componentsToHide];
    }

    // @Note: Issue in jQuery, when specifying a hide timeout & callback
    // when multiple elements not all of them were getting hidden instead
    // scrollTop as it's hiding (should be instant anyways)
    $(componentsAsSelectors(componentsToHide)).hide();
    $('body,html').scrollTop(0);
  };
}

window.merchantos.page = new Page();
